import React from 'react'
//@ts-ignore
import s from './HintWrap.module.scss'
import { Hint } from '../../Hint/Hint';
//@ts-ignore
import { getUrlImg } from '../../../utils/utilsFunctions';

type HintT = {
    img?: string
    alt?: string
    text: string
    moreLink?: string
    moreText?: string
}
type HintWrapT = {
    children: any,
    hint: HintT
}
export const HintWrap = ({ ...props }: HintWrapT) => {
    let { children, hint } = props


    return (
        <div className={s.wrap}>
            {children}
            {hint && <Hint  >
                <div className={s.boxHint}>
                    <img src={getUrlImg(hint.img)} alt={hint.alt} />
                    <div className={s.text}>{hint.text}</div>
                    {hint.moreLink && <a href={hint.moreLink}>{hint.moreText}</a>}

                </div>
            </Hint>}

        </div>
    )
}
